import { useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { CourseSet } from "../../types/requirement.response";
import { getCourseKey } from "../../utils/courseUtils";
import { getCourseSetSlotInfo } from "../../utils/requirementResponseUtils";
import SidebarCourseRow from "./SidebarCourseRow";
import SidebarAddCourse from "./SidebarAddCourse";

interface SidebarCourseSetSlotsProps {
    courseSet: CourseSet;
    coursesMap: Record<string, CourseSummary>;
    requirementId: string;
    onAdd: (course: AddableCourse) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    idPrefix: string;
    isBroad?: boolean;
    onAddExtra?: (course: AddableCourse) => void | Promise<void>;
}

export default function SidebarCourseSetSlots({
    courseSet,
    coursesMap,
    requirementId,
    onAdd,
    onDelete,
    idPrefix,
    isBroad,
    onAddExtra,
}: SidebarCourseSetSlotsProps) {
    const { appliedCourses, unappliedCourses, allCourses, emptySlotCount, isFulfilled, label } = useMemo(
        () => getCourseSetSlotInfo(courseSet, coursesMap),
        [courseSet, coursesMap]
    );

    return (
        <>
            {appliedCourses.map(({ course, isApplied }) => (
                <SidebarCourseRow
                    key={getCourseKey(course)}
                    course={course}
                    isApplied={isApplied}
                    nodeId={courseSet.id}
                    requirementId={requirementId}
                    onDelete={onDelete}
                />
            ))}
            {Array.from({ length: emptySlotCount }, (_, i) => (
                <SidebarAddCourse
                    key={`${idPrefix}-${courseSet.id}-${i}`}
                    allCourses={allCourses}
                    onAdd={onAdd}
                    label={label}
                    nodeId={courseSet.id}
                    dropId={`${idPrefix}-slot-${courseSet.id}-${i}`}
                    isBroad={isBroad}
                />
            ))}
            {unappliedCourses.map(({ course, isApplied }) => (
                <SidebarCourseRow
                    key={getCourseKey(course)}
                    course={course}
                    isApplied={isApplied}
                    nodeId={courseSet.id}
                    requirementId={requirementId}
                    onDelete={onDelete}
                />
            ))}
            {isFulfilled && onAddExtra && (
                <SidebarAddCourse
                    allCourses={allCourses}
                    onAdd={onAddExtra}
                    nodeId={null}
                    dropId={`${idPrefix}-slot-${courseSet.id}-extra`}
                    isBroad={isBroad}
                />
            )}
        </>
    );
}
